module.exports = __webpack_public_path__ + "img/newsImg11-17.fb2580e1.png";